import { format } from "date-fns";

// Here's why this code is hacky:
// All of our dates on the BE are stored in UTC
// Some like transaction date need to be displayed in the native TZ
// Others like the date of birth or payment due date need to be displayed in UTC
// By default date-fns will format the date in the local TZ
// This is problematic for the dates that need to be displayed in UTC
export const addTimezoneOffsetToUTCZeroTimeIfNeeded = (date: Date | string) => {
  const dateObj = new Date(date);
  if (typeof date === "string" && date.length === 10) {
    return new Date(
      dateObj.valueOf() + dateObj.getTimezoneOffset() * 60 * 1000,
    );
  } else if (
    date instanceof Date &&
    date.toISOString().endsWith("00:00:00.000Z")
  ) {
    return new Date(
      dateObj.valueOf() + dateObj.getTimezoneOffset() * 60 * 1000,
    );
  }
  return dateObj;
};

export const removeTimezoneOffsetIfNeeded = (date: Date | string) => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  const timezoneOffset = dateObj.getTimezoneOffset() * 60 * 1000;
  return new Date(dateObj.getTime() - timezoneOffset);
};

export const formatDate = (
  date: Date | string | undefined,
  formatStr: string | undefined = "MM/dd/yy",
) => {
  if (!date) {
    return "";
  }
  const dtDateOnly = addTimezoneOffsetToUTCZeroTimeIfNeeded(date);
  return format(dtDateOnly, formatStr);
};

const getOrdinalSuffix = (day: number) => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatLongDate = (date: Date | string | undefined) => {
  if (!date) {
    return "";
  }
  const dtDateOnly = addTimezoneOffsetToUTCZeroTimeIfNeeded(date);
  const day = parseInt(format(dtDateOnly, "d"), 10);
  const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;
  const month = format(dtDateOnly, "MMMM");
  const year = format(dtDateOnly, "yyyy");
  return `${month} ${dayWithSuffix}, ${year}`;
};
